// Texts of the sign-in and create-account windows the checkout opens (contact step).
// Keys start with "account.".

const en = {
  // Shared by the windows
  "account.password": "Password",
  "account.passwordRule": "At least 6 characters",
  "account.invalidEmailFormat": "Invalid email format. Example: example@example.com",
  "account.backToSignIn": "Back to Sign In",
  "account.backToSignInButton": "Back to Sign in",
  "account.codeSendError": "Error occurred while sending verification code. Please try again or contact support!",

  // SignInForm
  "account.signIn.title": "Sign In",
  "account.signIn.button": "Sign in",
  "account.signIn.signing": "Signing",
  "account.signIn.forgot": "Forgot Password?",
  "account.signIn.noAccount": "Don't have an account?",
  "account.signIn.register": "Register",
  "account.signIn.error": "Invalid Email or Password, Either the email is incorrect or the password. Please check and try again.",
  "account.signIn.disabled": "This account is deactivated. Ask your team's owner or admin to reactivate it, or contact us.",

  // Signing in with a code by email (EmailCodeSignIn, and the offer in SignInForm)
  "account.code.or": "or",
  "account.code.button": "Email me a sign-in code",
  "account.code.wrongPassword": "The email or password isn't right.",
  "account.code.offer": "Sign in with a code by email instead",
  "account.code.title": "Sign in with a code",
  "account.code.intro": "We'll email you a 6-digit code. No password needed.",
  "account.code.send": "Email me a code",
  "account.code.sending": "Sending",
  "account.code.sentTo": "We sent a 6-digit code to",
  "account.code.expires": "It expires in 10 minutes.",
  "account.code.label": "6-digit code",
  "account.code.resend": "Send a new code",
  "account.code.resendIn": "Send a new code in {seconds}s",
  "account.code.otherEmail": "Use another email",
  "account.code.usePassword": "Sign in with your password",
  "account.code.invalid": "That code isn't right. Check the email and try again.",
  "account.code.expired": "This code expired or had too many tries. Send a new one.",
  "account.code.tooMany": "Too many tries. Please wait a few minutes and try again.",
  "account.code.error": "We couldn't sign you in. Please try again.",

  // The checkout's email has an account (AccountExistsHint)
  "account.exists.text": "You already have an account with this email.",
  "account.exists.signIn": "Sign in",

  // ForgotPasswordForm
  "account.forgot.title": "Forgot Password",
  "account.forgot.text": "Please enter the email associated with your account",
  "account.forgot.send": "Send Code",
  "account.forgot.sending": "Sending",
  "account.forgot.sent": "Verification code sent, Please check your email for verification code!",

  // VerificationCode
  "account.verify.title": "Verification Code",
  "account.verify.sentTo": "We've sent a code to",
  "account.verify.wrongCode": "Wrong code, please try again",
  "account.verify.sendAgain": "Send code again",
  "account.verify.button": "Verify",
  "account.verify.verifying": "Verifing",
  "account.verify.resent": "Verficiation code resent, Please check your email for new verifcation code!",
  "account.verify.invalid": "Invalid Verification code. The code entered is incorrect or expired, Please, try again.",
  "account.verify.invalidSupport": "Invalid Verification code. The code entered is incorrect or expired, Please, try again. If it persists, contact technical support at support@everbary.com",
  "account.verify.error": "An error occurred while verifying the code. Please try again later.",

  // ResetPassword
  "account.reset.title": "Reset password",
  "account.reset.newPassword": "New Password",
  "account.reset.button": "Reset Password",
  "account.reset.resetting": "Reseting",
  "account.reset.failed": "Error occurred while resetting password. Please try again or contact support!",
  "account.reset.error": "An error occurred while resetting the password. Please try again later.",

  // PasswordChanged
  "account.changed.title": "Password Changed",
  "account.changed.text": "Your password has been changed succesfully",

  // CreateAccount
  "account.create.titleBusiness": "Create a Business Account",
  "account.create.titlePersonal": "Create a Personal Account",
  "account.create.title": "Create Account",
  "account.create.selectType": "Select Account Type",
  "account.create.personal": "Personal",
  "account.create.personalText": "Ideal for individuals who make one or more orders",
  "account.create.business": "Business",
  "account.create.businessText": "Ideal for long-term customers and businesses",
  "account.create.businessClients": "Add personal clients to the order",
  "account.create.businessTeam": "Create a team",
  "account.create.businessPayLater": "Pay for orders at a time convenient for you",
  "account.create.companyName": "Company Name",
  "account.create.referralInvited": "{firm} invited you",
  "account.create.referralBenefit": "Open your firm's account and get {amount} in credit after your first paid order.",
  "account.create.referralBenefitBoth": "Open your account with their link: once you've paid {threshold} for orders in your first {days} days, you both get {amount} in translation credit.",
  "account.create.referralHave": "Have a referral code?",
  "account.create.referralCode": "Referral code (optional)",
  "account.create.referralUnknown": "We don't know that code. Please, check it.",
  "account.create.referralFrom": "Referred by {firm}",
  "account.create.hearTitle": "How did you hear about us?",
  "account.create.button": "Create an Account",
  "account.create.creatingDots": "Creating...",
  "account.create.creating": "Creating",
  "account.create.haveAccount": "If you have an account",
  "account.create.signIn": "Sign In",
  "account.create.created": "Your account has been created!",
  "account.create.emailInUseTitle": "Email Already in Use",
  "account.create.emailInUse": "The email is already in use. Please, try another one.",
  "account.create.weakPasswordTitle": "Weak Password",
  "account.create.weakPassword": "The password is too weak. Please, try again.",
  "account.create.unexpected": "An unexpected error occurred. Please, try again.",
  "account.create.missingNames": "Please fill first name or company name.",

  // AccountCreated
  "account.createdTitle": "Account Created",
  "account.createdText": ({ type }) => `You have successfully created a ${type} account`,
  "account.goToAccount": "Go to Account",
};

const es = {
  "account.password": "Contraseña",
  "account.passwordRule": "Al menos 6 caracteres",
  "account.invalidEmailFormat": "El formato del correo electrónico no es válido. Ejemplo: nombre@ejemplo.com",
  "account.backToSignIn": "Volver a iniciar sesión",
  "account.backToSignInButton": "Volver a iniciar sesión",
  "account.codeSendError": "No pudimos enviar el código de verificación. Vuelva a intentarlo o comuníquese con soporte.",

  "account.signIn.title": "Iniciar sesión",
  "account.signIn.button": "Iniciar sesión",
  "account.signIn.signing": "Iniciando sesión",
  "account.signIn.forgot": "¿Olvidó su contraseña?",
  "account.signIn.noAccount": "¿No tiene una cuenta?",
  "account.signIn.register": "Regístrese",
  "account.signIn.error": "El correo electrónico o la contraseña no son correctos. Revíselos y vuelva a intentarlo.",
  "account.signIn.disabled": "Esta cuenta está desactivada. Pídale al propietario o a un administrador de su equipo que la reactive, o contáctenos.",

  "account.code.or": "o",
  "account.code.button": "Recibir un código por correo",
  "account.code.wrongPassword": "El correo electrónico o la contraseña no son correctos.",
  "account.code.offer": "Entrar con un código por correo",
  "account.code.title": "Entrar con un código",
  "account.code.intro": "Le enviaremos un código de 6 dígitos por correo. No necesita contraseña.",
  "account.code.send": "Enviarme un código",
  "account.code.sending": "Enviando",
  "account.code.sentTo": "Enviamos un código de 6 dígitos a",
  "account.code.expires": "Vence en 10 minutos.",
  "account.code.label": "Código de 6 dígitos",
  "account.code.resend": "Enviar un código nuevo",
  "account.code.resendIn": "Enviar un código nuevo en {seconds} s",
  "account.code.otherEmail": "Usar otro correo",
  "account.code.usePassword": "Entrar con su contraseña",
  "account.code.invalid": "El código no es correcto. Revise el correo y vuelva a intentarlo.",
  "account.code.expired": "El código venció o tuvo demasiados intentos. Pida uno nuevo.",
  "account.code.tooMany": "Demasiados intentos. Espere unos minutos y vuelva a intentarlo.",
  "account.code.error": "No pudimos iniciar su sesión. Vuelva a intentarlo.",

  "account.exists.text": "Ya tiene una cuenta con este correo electrónico.",
  "account.exists.signIn": "Iniciar sesión",

  "account.forgot.title": "Recuperar contraseña",
  "account.forgot.text": "Ingrese el correo electrónico asociado a su cuenta",
  "account.forgot.send": "Enviar código",
  "account.forgot.sending": "Enviando",
  "account.forgot.sent": "Le enviamos un código de verificación. Revise su correo electrónico.",

  "account.verify.title": "Código de verificación",
  "account.verify.sentTo": "Enviamos un código a",
  "account.verify.wrongCode": "Código incorrecto. Vuelva a intentarlo.",
  "account.verify.sendAgain": "Reenviar código",
  "account.verify.button": "Verificar",
  "account.verify.verifying": "Verificando",
  "account.verify.resent": "Le reenviamos el código de verificación. Revise su correo electrónico.",
  "account.verify.invalid": "El código de verificación no es válido: es incorrecto o ya venció. Vuelva a intentarlo.",
  "account.verify.invalidSupport": "El código de verificación no es válido: es incorrecto o ya venció. Vuelva a intentarlo. Si el problema continúa, escriba a soporte técnico a support@everbary.com.",
  "account.verify.error": "Ocurrió un error al verificar el código. Vuelva a intentarlo más tarde.",

  "account.reset.title": "Restablecer contraseña",
  "account.reset.newPassword": "Nueva contraseña",
  "account.reset.button": "Restablecer contraseña",
  "account.reset.resetting": "Restableciendo",
  "account.reset.failed": "No pudimos restablecer la contraseña. Vuelva a intentarlo o comuníquese con soporte.",
  "account.reset.error": "Ocurrió un error al restablecer la contraseña. Vuelva a intentarlo más tarde.",

  "account.changed.title": "Contraseña actualizada",
  "account.changed.text": "Su contraseña se cambió correctamente.",

  "account.create.titleBusiness": "Crear una cuenta de empresa",
  "account.create.titlePersonal": "Crear una cuenta personal",
  "account.create.title": "Crear cuenta",
  "account.create.selectType": "Elija el tipo de cuenta",
  "account.create.personal": "Personal",
  "account.create.personalText": "Ideal para personas que hacen uno o más pedidos",
  "account.create.business": "Empresa",
  "account.create.businessText": "Ideal para clientes habituales y empresas",
  "account.create.businessClients": "Agregar a sus clientes particulares al pedido",
  "account.create.businessTeam": "Crear un equipo",
  "account.create.businessPayLater": "Pagar los pedidos cuando le resulte más conveniente",
  "account.create.companyName": "Nombre de la empresa",
  "account.create.referralInvited": "{firm} lo invitó",
  "account.create.referralBenefit": "Abra la cuenta de su estudio y reciba {amount} de crédito después de su primer pedido pagado.",
  "account.create.referralBenefitBoth": "Abra su cuenta con este enlace: cuando haya pagado {threshold} en pedidos en sus primeros {days} días, ambos reciben {amount} de crédito para traducciones.",
  "account.create.referralHave": "¿Tiene un código de referido?",
  "account.create.referralCode": "Código de referido (opcional)",
  "account.create.referralUnknown": "No reconocemos ese código. Revíselo, por favor.",
  "account.create.referralFrom": "Referido por {firm}",
  "account.create.hearTitle": "¿Cómo se enteró de nosotros?",
  "account.create.button": "Crear cuenta",
  "account.create.creatingDots": "Creando...",
  "account.create.creating": "Creando",
  "account.create.haveAccount": "¿Ya tiene una cuenta?",
  "account.create.signIn": "Inicie sesión",
  "account.create.created": "¡Su cuenta se creó correctamente!",
  "account.create.emailInUseTitle": "Correo ya registrado",
  "account.create.emailInUse": "Ya hay una cuenta con este correo electrónico. Pruebe con otro o inicie sesión.",
  "account.create.weakPasswordTitle": "Contraseña débil",
  "account.create.weakPassword": "La contraseña es demasiado débil. Elija una más segura y vuelva a intentarlo.",
  "account.create.unexpected": "Ocurrió un error inesperado. Vuelva a intentarlo.",
  "account.create.missingNames": "Complete su nombre o el nombre de la empresa.",

  "account.createdTitle": "Cuenta creada",
  "account.createdText": ({ type }) => {
    const kind = type === "business" ? " de empresa" : type === "personal" ? " personal" : "";
    return `Su cuenta${kind} se creó correctamente`;
  },
  "account.goToAccount": "Ir a mi cuenta",
};

const pt = {
  "account.password": "Senha",
  "account.passwordRule": "Pelo menos 6 caracteres",
  "account.invalidEmailFormat": "O formato do e-mail não é válido. Exemplo: nome@exemplo.com",
  "account.backToSignIn": "Voltar para entrar",
  "account.backToSignInButton": "Voltar para entrar",
  "account.codeSendError": "Não conseguimos enviar o código de verificação. Tente novamente ou fale com o suporte.",

  "account.signIn.title": "Entrar",
  "account.signIn.button": "Entrar",
  "account.signIn.signing": "Entrando",
  "account.signIn.forgot": "Esqueceu sua senha?",
  "account.signIn.noAccount": "Não tem uma conta?",
  "account.signIn.register": "Cadastre-se",
  "account.signIn.error": "O e-mail ou a senha não estão corretos. Confira e tente novamente.",
  "account.signIn.disabled": "Esta conta está desativada. Peça ao proprietário ou a um administrador da sua equipe que a reative, ou fale conosco.",

  "account.code.or": "ou",
  "account.code.button": "Receber um código por e-mail",
  "account.code.wrongPassword": "O e-mail ou a senha não estão corretos.",
  "account.code.offer": "Entrar com um código por e-mail",
  "account.code.title": "Entrar com um código",
  "account.code.intro": "Enviaremos um código de 6 dígitos por e-mail. Você não precisa de senha.",
  "account.code.send": "Enviar um código",
  "account.code.sending": "Enviando",
  "account.code.sentTo": "Enviamos um código de 6 dígitos para",
  "account.code.expires": "Ele vence em 10 minutos.",
  "account.code.label": "Código de 6 dígitos",
  "account.code.resend": "Enviar um novo código",
  "account.code.resendIn": "Enviar um novo código em {seconds} s",
  "account.code.otherEmail": "Usar outro e-mail",
  "account.code.usePassword": "Entrar com sua senha",
  "account.code.invalid": "O código não está correto. Confira o e-mail e tente novamente.",
  "account.code.expired": "O código venceu ou teve tentativas demais. Peça um novo.",
  "account.code.tooMany": "Tentativas demais. Aguarde alguns minutos e tente novamente.",
  "account.code.error": "Não conseguimos fazer seu login. Tente novamente.",

  "account.exists.text": "Você já tem uma conta com este e-mail.",
  "account.exists.signIn": "Entrar",

  "account.forgot.title": "Recuperar senha",
  "account.forgot.text": "Digite o e-mail associado à sua conta",
  "account.forgot.send": "Enviar código",
  "account.forgot.sending": "Enviando",
  "account.forgot.sent": "Enviamos um código de verificação. Confira seu e-mail.",

  "account.verify.title": "Código de verificação",
  "account.verify.sentTo": "Enviamos um código para",
  "account.verify.wrongCode": "Código incorreto. Tente novamente.",
  "account.verify.sendAgain": "Reenviar código",
  "account.verify.button": "Verificar",
  "account.verify.verifying": "Verificando",
  "account.verify.resent": "Reenviamos o código de verificação. Confira seu e-mail.",
  "account.verify.invalid": "O código de verificação não é válido: está incorreto ou já venceu. Tente novamente.",
  "account.verify.invalidSupport": "O código de verificação não é válido: está incorreto ou já venceu. Tente novamente. Se o problema continuar, escreva para o suporte técnico em support@everbary.com.",
  "account.verify.error": "Ocorreu um erro ao verificar o código. Tente novamente mais tarde.",

  "account.reset.title": "Redefinir senha",
  "account.reset.newPassword": "Nova senha",
  "account.reset.button": "Redefinir senha",
  "account.reset.resetting": "Redefinindo",
  "account.reset.failed": "Não conseguimos redefinir a senha. Tente novamente ou fale com o suporte.",
  "account.reset.error": "Ocorreu um erro ao redefinir a senha. Tente novamente mais tarde.",

  "account.changed.title": "Senha atualizada",
  "account.changed.text": "Sua senha foi alterada.",

  "account.create.titleBusiness": "Criar uma conta empresarial",
  "account.create.titlePersonal": "Criar uma conta pessoal",
  "account.create.title": "Criar conta",
  "account.create.selectType": "Escolha o tipo de conta",
  "account.create.personal": "Pessoal",
  "account.create.personalText": "Ideal para pessoas que fazem um ou mais pedidos",
  "account.create.business": "Empresa",
  "account.create.businessText": "Ideal para clientes frequentes e empresas",
  "account.create.businessClients": "Adicionar seus clientes particulares ao pedido",
  "account.create.businessTeam": "Criar uma equipe",
  "account.create.businessPayLater": "Pagar os pedidos quando for mais conveniente",
  "account.create.companyName": "Nome da empresa",
  "account.create.referralInvited": "{firm} convidou você",
  "account.create.referralBenefit": "Abra a conta do seu escritório e receba {amount} de crédito depois do seu primeiro pedido pago.",
  "account.create.referralBenefitBoth": "Abra sua conta com este link: quando você tiver pago {threshold} em pedidos nos seus primeiros {days} dias, ambos recebem {amount} de crédito para traduções.",
  "account.create.referralHave": "Tem um código de indicação?",
  "account.create.referralCode": "Código de indicação (opcional)",
  "account.create.referralUnknown": "Não reconhecemos esse código. Confira, por favor.",
  "account.create.referralFrom": "Indicado por {firm}",
  "account.create.hearTitle": "Como você nos conheceu?",
  "account.create.button": "Criar conta",
  "account.create.creatingDots": "Criando...",
  "account.create.creating": "Criando",
  "account.create.haveAccount": "Já tem uma conta?",
  "account.create.signIn": "Entre",
  "account.create.created": "Sua conta foi criada!",
  "account.create.emailInUseTitle": "E-mail já cadastrado",
  "account.create.emailInUse": "Já existe uma conta com este e-mail. Tente outro ou entre na sua conta.",
  "account.create.weakPasswordTitle": "Senha fraca",
  "account.create.weakPassword": "A senha é fraca demais. Escolha uma mais segura e tente novamente.",
  "account.create.unexpected": "Ocorreu um erro inesperado. Tente novamente.",
  "account.create.missingNames": "Preencha seu nome ou o nome da empresa.",

  "account.createdTitle": "Conta criada",
  "account.createdText": ({ type }) => {
    const kind = type === "business" ? " empresarial" : type === "personal" ? " pessoal" : "";
    return `Sua conta${kind} foi criada`;
  },
  "account.goToAccount": "Ir para minha conta",
};

const texts = { en, es, pt };

export default texts;
